(function(){
    'use strict';

    angular.module('Services').factory('CarrierLoadRatesPPTableService', CarrierLoadRatesPPTableService);
    CarrierLoadRatesPPTableService.$inject = ['Carrier', 'TableLiteFactory', '$uibModal', 'toastr'];

    function CarrierLoadRatesPPTableService(Carrier, TableLiteFactory, $uibModal, toastr) {
        return (serviceProfile, options)=> {
            console.log(serviceProfile.service.rateCategories);
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/CarrierLoadRatesPPTableService.js